import { useMemo, type FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import { useModalConfirm } from "@ryde/redux";
import {
  ConfirmResult,
  dropdownAtomFamily,
  NO_VALUE_DISPLAY,
} from "@ryde/shared";

import { ColorIconButton } from "../../../controls";
import { RatioOvernightMarker } from "./ratio-overnight-marker";
import type { IRatioItemFormProps } from "./table-ratios.models";
import { RatioItemDisplayStyled } from "./table-ratios.styled";

export const RatioItemDisplay: FC<Partial<IRatioItemFormProps>> = ({
  removeHandler,
  index,
  onEdit,
  value,
}) => {
  const { t } = useTranslation();
  const { confirmDialogResult } = useModalConfirm();
  const areaItems = useRecoilValue(dropdownAtomFamily("area"));

  const onArchiveClickEvent = useEvent(async (): Promise<void> => {
    const confirmationResult = await confirmDialogResult({
      title: t("general.CONFIRM"),
      message: t("general.ITEM_DELETE_MESSAGE"),
    });

    if (confirmationResult === ConfirmResult.OK) {
      removeHandler?.(index || 0);
    }
  });

  const areaItemName: string = useMemo(() => {
    if (!value?.areaId) {
      return NO_VALUE_DISPLAY;
    }

    return (
      areaItems.find(item => Number(item.value) === Number(value.areaId))
        ?.label || NO_VALUE_DISPLAY
    );
  }, [areaItems, value?.areaId]);
  const from = value?.from ?? NO_VALUE_DISPLAY;
  const to = value?.to ?? NO_VALUE_DISPLAY;

  return (
    <RatioItemDisplayStyled className="display-mode">
      <p>{areaItemName}</p>
      <p> {from}</p>
      <p className="to_cell">
        {to}{" "}
        <RatioOvernightMarker from={value?.from || ""} to={value?.to || ""} />
      </p>
      <p> {value?.ratio}</p>
      <div>
        <ColorIconButton iconType="EDIT" onClick={() => onEdit?.()} />
        <ColorIconButton
          iconType="DELETE"
          onClick={() => onArchiveClickEvent()}
        />
      </div>
    </RatioItemDisplayStyled>
  );
};
